import type { CountryProps, CURRENCYCODETYPE } from 'BreetHelpers';

export const allCountries: CountryProps[] = [
	{ code: 'NG', name: 'Nigeria', dialCode: '+234', flag: '🇳🇬' },
	{ code: 'GH', name: 'Ghana', dialCode: '+233', flag: '🇬🇭' },
	{ code: 'US', name: 'United States', dialCode: '+1', flag: '🇺🇸' },
];

export const countries = allCountries.filter((i) => i.code === 'NG' || i.code === 'GH');

export const mapCountryCode: Record<string, CURRENCYCODETYPE> = {
	NG: 'NGN',
	GH: 'GHS',
	US: 'USD',
};
